import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class BankAccountValidatorService {
  public BankAccountValidator() {
    return (control: AbstractControl): ValidationErrors | null => {
      const iban = control.get('iban')?.value;
      const swiftCode = control.get('swiftCode')?.value;
      const bankName = control.get('bankName')?.value;

      if (!iban && !swiftCode && !bankName) {
        return null;
      }
      else {
        if (!iban || !swiftCode || !bankName) {
          return { incompleteBankAccount: true };
        }
      }

      return null;
    };
  }
}
